<template>
    <div class="policy_news"> 
        <div class="mbnx">
            <el-carousel :interval="5000" arrow="always" :height="bannerHeight + 'px'">
                <el-carousel-item v-for="(item, idnex) in items" :key="idnex">
                    <div>
                    <img
                        ref="bannerHeight"
                        :src="item.news_image_url"
                        alt=""
                        @load="imgload"
                        width="100%"
                    />
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="hou">
            <div class="dynamic">
                <p style="font-size: 30px;border-bottom:1px solid gainsboro;text-align:left;padding-bottom:10px;">新闻动态</p>
                <ul class="nanhai">
                    <li v-for="(dong,index) in tai" :key="index">
                        <div class="miao-bian"></div>
                        <p class="xin-shi"><font style="font-size:28px;">{{ dong.policy_news_date}}</font><br><font style="font-size:16px;padding-left:4%">{{ dong.policy_news_year}}</font></p>
                        <div class="fengba">
                            <div class="anchun"><img :src="dong.policy_news_image_url" alt=""  @click="qinai(dong.policy_news_id)"></div>
                            <div class="yue">   
                                <p style="font-size:24px">{{ dong.policy_news_title }}</p>
                                <p style="font-size:18px;">{{ dong.policy_news_content | ellipsis}}</p>
                            </div>
                        </div>
                    </li>
                </ul>
                <el-pagination
                    :current-page.sync="current_page"
                    background
                    layout="prev, pager, next"
                    :total=total
                    :page-size=6
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>


<script>
import axios from "axios";
export default {
    name: "policy_news",
    data() {
        return {
            bannerHeight: "",
            items:[],
            tai:[],
            total:this.total,
            current_page: 1,
            guan:[]
        }
    },
     watch: {
        current_page(to, from) {
            if (from != 0) {
                //搜索分页
                this.dong()
            }
        },
    },
    created(){
        this.infoshow()
        this.meng()
        this.dong()
    },
    methods:{
        imgload() {
            this.$nextTick(() => {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
            });
        },
        infoshow() {
            axios
                .get(this.$guide.api + "/infoshow_new_image/")
                // 接口地址
                .then((res) => {
                    this.items = res.data.context.news_image_info;
                });
        },
        meng(){
            axios
                .get(this.$guide.api + "/infoshow_policy_new_recommand/")
                // 接口地址
                .then((res) => {
                    this.guan = res.data.context.policy_news_recommand;
                    console.log(this.guan)
                });
        },
        dong(){
             axios
                .get(this.$guide.api + "/infoshow_policy_new/?" + "current_page="+ this.current_page + "&page_size=" + 6)
                // 接口地址
                .then((res) => {
                    this.tai = res.data.context.policy_current_page_news.page_policy_news_list;
                    this.total = res.data.context.policy_summary_news
                });
        },
        qinai(p){
            console.log(p)
            window.location.href="/news/policy_"+ p +".html"
        },
        
    },
    mounted() {
        window.scrollTo(0,0);
        window.addEventListener("scroll", this.btn_run);
        this.imgload();
        window.addEventListener(
        "resize",
            () => {
                this.bannerHeight = this.$refs.bannerHeight[0].height;
                this.imgload();
            },
        false
        );
    },
    filters: {
    // 当标题字数超出时，超出部分显示’...‘。此处限制超出8位即触发隐藏效果
    ellipsis (value) {
        if (!value) return ''
        if (value.length > 82) {
            return value.slice(0, 82) + "...."
        }
        return value
    }
}
}
</script>

<style >
*{
    margin: 0;
    padding: 0;
}
.policy_news{
    width: 99.92%;
    height: auto;
    border: 1px solid white;
    background: white;
}
.mbnx{
    width: 100%;
    height: auto;
    margin-top: 100px;
}
.hou{
    width: 60%;
    height: auto; 
    margin-left: 20%;
}
/* .hou .el-carousel{
    width: 100%;
    margin-top: 200px;
}
.hou .el-carousel img{
    width: 100%;
    height: 100%;
} */
.hou .dynamic{
    width: 100%;
    height: auto;
    margin-top: 50px;
}   
.dynamic .nanhai{
    width: 84%;
    height: auto;
    list-style: none;
    padding-left: 4%;
    margin-left: 12%;
    padding-top: 50px;
    border-left: 1px solid  #dddddd;
}
.dynamic .nanhai li{
    width: 100%;
    height: 200px;
    margin-top: 50px;
    background: white;
}
.dynamic .nanhai li:hover .miao-bian{
    border: 1px solid #6aa2ff;
}
.dynamic .nanhai li:hover{
    color:  #6aa2ff;
}
.dynamic .nanhai li:hover .yue p:nth-child(2){
    color:  #6aa2ff;
}
.dynamic .nanhai li:nth-child(1){
    margin-top: 0px;
}
.fengba{
    width: 100%;
    height: 100%;
    margin-top: -40px;
}
.miao-bian{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #999999;
    background: white;
    position: relative;
    top: 70px;
    left: -6%;
}
.xin-shi{
    position: relative;
    top: 38px;
    left: -62.5%;
}
.fengba .anchun{
    width: 31%;
    height: 100%;
    margin-left: 0px;
}
.fengba .anchun img{
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.yue{
    height: 100%;
    margin-top: -224px;
    margin-left: 34.5%;
    line-height: 30px;
}
.fengba .yue p{
    margin-top: 30px;
    text-align: left;
}
.fengba .yue p:nth-child(1){
    margin-top: 50px;
}
.fengba .yue p:nth-child(2){
    color:#666666;
}
.yue span{
    display: block;
    margin-left: 60%;
    margin-top: -20px;
    cursor: pointer;
}
.yue span img {
    position: relative;
    left: 45px;
    top: -17px;
}      
.el-pagination{
    margin-bottom: 30px;
}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
</style>